<div provide-parent-form *ngIf="report">
	<div class="field-group">
		<h3>{{ 'RECIPIENTS' | translate }} <bb-info [contents]="'HELP.REPORT_RECIPIENTS' | translate"></bb-info>
		</h3>
	
		<bb-form-element [form]="form" [label]="'SEND_REPORT_TO' | translate">
			<div class="flex-display" *ngFor="let emailAdress of report.recipients; let i = index; trackBy: trackByIndex">
				<input [(ngModel)]="report.recipients[i]" type="text" name="report-recipients-{{i}}" />
				<div *ngIf="i !== 0" class="remove-email" (click)="removeEmail(i)">
					<i class="fa fa-times"></i>
				</div>
			</div>
			<bb-button [icon]="'plus'" (click)="addEmail()">
				{{ 'ADD_EMAIL_ADDRESS' | translate }}
			</bb-button>
		</bb-form-element>
	</div>

	<div class="field-group">
		<h3>{{ 'SCHEDULE' | translate }} <bb-info [contents]="'HELP.REPORT_AUTOMATION' | translate"></bb-info>
		</h3>

		<mat-form-field appearance="fill" class="full-width">
			<mat-label>{{'GENERATE_REPORT' | translate}}</mat-label>
			<mat-select [(ngModel)]="report.generateInterval " name="generateInterval">
				<mat-option *ngFor="let option of generateReportOptions" [value]="option.value">{{option.label}}</mat-option>
			</mat-select>
		</mat-form-field>
		
		<mat-form-field appearance="fill" class="full-width" *ngIf="report.generateInterval === 'weekly'">
			<mat-label>{{'DAY' | translate}}</mat-label>
			<mat-select [(ngModel)]="report.generateIntervalDays " name="generateIntervalDays">
				<mat-option *ngFor="let weekday of weekdays" [value]="weekday.value">{{weekday.label}}</mat-option>
			</mat-select>
		</mat-form-field>

		<bb-form-element [form]="form" [label]="'QUEUE_TO_EMAIL_DIRECTLY' | translate">
			<bb-button [icon]="'cog'" (click)="generateReportNow()"
				[disabled]="!report.id || report.id <= 0 || form.dirty || !report.recipients">
				{{ 'GENERATE_NOW' | translate }}
			</bb-button>
			<p *ngIf="!report.id || report.id <= 0 || form.dirty">
				<small>{{ 'GENERATE_NOW_AVAILABLE_AFTER_SAVE' | translate }}</small></p>
		</bb-form-element>
	</div>
</div>
